import { Component, Input } from '@angular/core';

@Component({
  template: ''
})

export class IconComponent {
  @Input() color!: string;
}
